var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-form-item',{attrs:{"label":_vm.currentField.label,"label-width":_vm.currentField.labelWidth + 'px'}},[_c('el-input',_vm._b({model:{value:(_vm.number),callback:function ($$v) {_vm.number=_vm._n($$v)},expression:"number"}},'el-input',_vm.attributesBinding,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }